import {
    apiRequest,
    mertuaList,
    mertuaActive,
    mertuaInactive
} from "../../../../../../services/adapters/kepegawaian/mertuaService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", mertuaList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", mertuaInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", mertuaActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository